<template>
  <v-tour name="tour" :steps="steps" :options="options" :callbacks="callbacks">
  </v-tour>
</template>

<script>
export default {
  name: "CatalogTourComponent",
  data() {
    return {
      callbacks: {
        onSkip: this.tourStepFinish,
        onFinish: this.tourStepFinish
      },
      options: {
        useKeyboardNavigation: false,
        labels: {
          buttonSkip: "Cerrar",
          buttonPrevious: "Anterior",
          buttonNext: "Continuar",
          buttonStop: "Finalizar"
        }
      },
      steps: [
        {
          target: "#app",
          content: `
            <h5>Paso 1 de 2</h5>
            <h6>Arma tu catálogo de productos y servicios</h6>
            <p>Carga una vez tus ítems con precio, impuestos y unidades. Después los seleccionas en cualquier documento con un solo clic.</p>
          `
        },
        {
          target: "#app",
          content: `
            <h5>Paso 2 de 2</h5>
            <h6>Organiza con categorías</h6>
            <p>Crea categorías antes para mantener tu catálogo ordenado y filtrar productos rápido al cotizar o facturar.</p>
          `
        }
      ]
    };
  },
  computed: {},
  methods: {
    tourStepFinish() {
      const userConfigGeneral = {
        is_catalog_tour_completed: 1
      };
      this.$store.dispatch("userConfigGeneralUpdated", userConfigGeneral);
    }
  },
  mounted() {
    this.$tours["tour"].start();
  }
};
</script>

<style lang="scss" scoped></style>
